/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ score: NonNullable<unknown> }} Audit_Details_Source_RelevanceInputs */



/**
* | output |
* | --- |
* | "{score}% relevance" |
*
* @param {Audit_Details_Source_RelevanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_source_relevance = /** @type {((inputs: Audit_Details_Source_RelevanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Source_RelevanceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.score}% Relevanz`)
	return /** @type {LocalizedString} */ (`${i?.score}% relevance`)
});